import { Box } from "@chakra-ui/react";

import { RanaMapButtons } from "./components/rana-map-buttons";
import { FullscreenRanaMapControls } from "./components/rana-map-controls";
import RanaMapLayers from "./components/rana-map-layers";
import { RanaMapScale, RanaMapScaleProps } from "./components/rana-map-scale";
import { RanaMapSelf } from "./components/rana-map-self";
import { useFullscreen } from "./hooks/use-fullscreen";
import { useRanaMap } from "./hooks/use-rana-map";
import { RanaMapProps } from "./types/rana-map-props-types";

const { ControlsBottom, ...ExportRanaMapControls } = FullscreenRanaMapControls;
function RanaMapFullscreen(props: RanaMapProps) {
  const { mapId, containerProps, commentProps, sprites, hideExport, initialFullscreen } = props;
  const hookReturn = useRanaMap(mapId, sprites);
  const { mapContainerRef, fullscreen, setFullscreen } = useFullscreen(initialFullscreen);
  const { isThreeD, setThreeD, zoomIn, zoomOut, toFlat, show3DBuildings, setShow3DBuildings } =
    hookReturn;

  return (
    <Box
      h="full"
      w="full"
      position="fixed"
      zIndex="fullscreenmap"
      top={0}
      left={0}
      bg="brand.bg"
      ref={mapContainerRef}
      {...containerProps}
    >
      {/* Sidebar */}
      <ControlsBottom overflow="visible" mb={3} rounded="base">
        {commentProps && (
          <>
            <RanaMapButtons.Inspect
              onClick={() => commentProps?.setIsAddingComment(false)}
              isActive={!commentProps?.isAddingComment}
              roundL
            />
            <RanaMapButtons.AddComment
              canComment={commentProps.canComment}
              isAddingComment={commentProps.isAddingComment}
              setIsAddingComment={commentProps.setIsAddingComment}
            />
          </>
        )}
        <RanaMapButtons.BackgroundMap mapId={mapId} roundL={!commentProps} />
        <RanaMapButtons.BuildingsAndTerrain
          show3DBuildings={show3DBuildings}
          setShow3DBuildings={setShow3DBuildings}
        />
        {!hideExport && <RanaMapButtons.MapExport fullscreen={fullscreen} mapId={mapId} />}

        <RanaMapButtons.Fullscreen fullscreen={fullscreen} setFullscreen={setFullscreen} />
        <RanaMapButtons.ThreeD isThreeD={isThreeD} setThreeD={setThreeD} />
        <RanaMapButtons.Compass mapId={mapId} toFlat={toFlat} />
        <RanaMapButtons.ZoomIn zoomIn={zoomIn} />
        <RanaMapButtons.ZoomOut zoomOut={zoomOut} />
        <RanaMapButtons.ScreenRecord />
        <RanaMapButtons.Attribution roundR />
      </ControlsBottom>
      {/* Map */}
      <RanaMapSelf {...props} {...hookReturn} />
    </Box>
  );
}

const RanaMapExport = Object.assign(RanaMapFullscreen, RanaMapLayers, ExportRanaMapControls, {
  MapButton: RanaMapButtons.MapButton,
  MapScale: ({ right = 4 }: Partial<RanaMapScaleProps>) => RanaMapScale({ right }),
});

// This is not a real default export, the elements of the object function as named exports.
// eslint-disable-next-line import/no-default-export
export default RanaMapExport;
